import styled, { keyframes } from 'styled-components';

const anim = keyframes`
    0% {
        transform: translateY(0);
        opacity: .2;
    }
    50% {
        transform: translateY(-10px);
        opacity: .6;
    }
    100% {
        transform: translateY(0);
        opacity: .2;
    }
`;

export const LoaderWrap = styled.div`
    display: block;
    width: 100%;
    text-align: center;
    padding: 20px 0;
    clear: both;
`;

export const Loader = styled.div`
    width: 45px;
    height: 10px;
    font-size: 0;
    margin: auto auto -6px;
`;

export const LoaderItem = styled.div`
    display: inline-block;
    width: 9px;
    height: 9px;
    margin-left: 6px;
    border-radius: 50%;
    background: #8b9cab;
    animation: ${anim} .8s infinite linear;

    &:nth-child(2) {
        animation-delay: -.6s;
    }

    &:nth-child(3) {
        animation-delay: -.4s;
    }
`;
